<script>

	import {uploadImg} from './csql.js'
	import { createEventDispatcher } from 'svelte';
	export let image_id


	const dispatch = createEventDispatcher();
	let Archivo = ''
	let loading=false
	function completed(){
		dispatch('uploaded', {id:image_id, filename:Archivo})
	}

	function add_photo(ev){
		let foto = ev.target.files[0]

		let filename = new Date().getTime()
		let file_extension = foto.name.split('.').pop()
		Archivo = `${filename}.${file_extension}`

		let formData = new FormData()
		formData.append('images', foto.name)
		
		resizeImage({
			file : foto,
			maxSize : 600
		})
			.then( img => {
				formData.append('file', img, `${filename}.${file_extension}`)
				//formData.append('file', img)
				formData.append('name', `${filename}.${file_extension}`)
				
				upload_foto(formData,)
			})
			.catch( err => {
				console.log(err)
			})
	}

	

	function resizeImage(settings){
		let file = settings.file;
	    let maxSize = settings.maxSize;
	    let reader = new FileReader();
	    let image = new Image();
	    let canvas = document.createElement('canvas');
	    let dataURItoBlob = function (dataURI) {
	        let bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
	            atob(dataURI.split(',')[1]) :
	            unescape(dataURI.split(',')[1]);
	        let mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
	        let max = bytes.length;
	        let ia = new Uint8Array(max);
	        for (let i = 0; i < max; i++)
	            ia[i] = bytes.charCodeAt(i);
	        return new Blob([ia], { type: mime });
	    };
	    let resize = function () {
	        let width = image.width;
	        let height = image.height;
	        if (width > height) {
	            if (width > maxSize) {
	                height *= maxSize / width;
	                width = maxSize;
	            }
	        } else {
	            if (height > maxSize) {
	                width *= maxSize / height;
	                height = maxSize;
	            }
	        }
	        canvas.width = width;
	        canvas.height = height;
	        //console.log(width,height)
	        canvas.getContext('2d').drawImage(image, 0, 0, width, height)
	        canvas.getContext('2d').fillStyle = "rgba(2,2,2,0.9)"
	        canvas.getContext('2d').font="bold 30px Roboto, Verdana, Times Roman"
	        canvas.getContext('2d').textBaseline = 'middle'
	      	canvas.getContext('2d').textAlign = 'center'
	        //canvas.getContext('2d').rotate(-Math.PI / 4)
	        //canvas.getContext('2d').translate(150,150)

	        // MARCA DE AGUA
	        canvas.getContext('2d').shadowOffsetX = 3;
			canvas.getContext('2d').shadowOffsetY = 3;
			/*
			canvas.getContext('2d').shadowColor = "rgba(0,0,0,0.4)";
	        canvas.getContext('2d').fillText("un poco mas", width/4, height*0.25)
	        canvas.getContext('2d').fillText("un poco mas", width/2, height*0.5)
	        canvas.getContext('2d').fillText("un poco mas", width/1.3, height*0.75)
	        */

	        //canvas.getContext('2d').fillText("1 un poco mas", 100, 100)
	        //canvas.getContext('2d').fillText("2 un poco mas", 150, 200)
	        //canvas.getContext('2d').fillText("3 un poco mas", 300, 300)
	        let dataUrl = canvas.toDataURL('image/jpeg');
	        return dataURItoBlob(dataUrl);
	    };
	    return new Promise(function (ok, no) {
	        if (!file.type.match(/image.*/)) {
	            no(new Error("Not an image"));
	            return;
	        }
	        reader.onload = function (readerEvent) {
	            image.onload = function () { return ok(resize()); };
	            image.src = readerEvent.target.result;
	        };
	        reader.readAsDataURL(file);
	    });
	}

	async function upload_foto(fd){
		loading=true
		const res = await uploadImg(fd,Archivo,image_id)
		loading = false
		
		if(res){
			dispatch('uploaded', {id:image_id, filename:Archivo})
		}else{
			alert("ERROR, no se realizo actualizacion!!!")
		}
	}


</script>
         
<label for="fileinput" class="button">
	{#if !loading}
	  	&plus; Foto
	{:else}
		Loading....
	{/if}  
</label>
<input id="fileinput" type="file" on:change={add_photo} class="hidden">

<style>
	input[type="file"]#fileinput{
		width: 0.1px;
		height: 0.1px;
		opacity: 0;
		overflow: hidden;
		position: absolute;
		z-index: -1;
		display: none;
 	}
 </style>